import { TextMap } from "../../types";

const es: TextMap = {
  choose_preferred_wallet: "Elige tu billetera preferida",
  connect_mobile_wallet: "Conectar a billetera móvil",
  scan_qrcode_with_wallet: "Escanea el código QR con una billetera compatible con WalletConnect",
  connect: "Conectar",
  // TODO: review following translations
  qrcode: "Código QR",
  mobile: "Móvil",
  copy_to_clipboard: "Copiar",
  copied_to_clipboard: "Copiado!",
  show_more: "Mostrar más",
  show_less: "Mostrar menos",
};

export default es;
